import {PropsWithChildren, useState} from "react";

import Button from "@/components/button/Button.tsx";
import {AllowBlockListModal} from "@/pages/statuspages/tabs/subscribers/components/allow-block-list/AllowBlockListModal.tsx";

export interface StatusPageSubscribersAllowBlackListActionButtonProps extends PropsWithChildren {}

export const StatusPageSubscribersAllowBlackListActionButton = ({
  children,
}: StatusPageSubscribersAllowBlackListActionButtonProps) => {
  const [show, setShow] = useState(false);
  return (
    <>
      <Button variant={"secondary"} onClick={() => setShow(true)} className={"text-nowrap"}>
        {children}
      </Button>
      <AllowBlockListModal show={show} setShow={setShow} />
    </>
  );
};
